import { Constants } from '@/assets'
import { Box } from '@mui/material'
import { EmtTypography } from 'emt-components-v2'
import { useTranslation } from 'react-i18next'
import PhoneInput, { Country, formatPhoneNumberIntl, getCountries } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const EXCLUDED_COUNTRIES: Country[] = [
  'BN', // Brunei Darussalam
  'CK', // Cook Islands
  'FJ', // Fiji
  'FM', // Federated States of Micronesia
  'ID', // Indonesia
  'KI', // Kiribati
  'KZ', // Kazakhstan
  'MH', // Marshall Islands
  'MY', // Malaysia
  'NC', // New Caledonia
  'NF', // Norfolk Island
  'NR', // Nauru
  'NU', // Niue
  'NZ', // New Zealand
  'PG', // Papua New Guinea
  'PH', // Philippines
  'RU', // Russia
  'SB', // Solomon Islands
  'SG', // Singapore
  'TH', // Thailand
  'TO', // Tonga
  'TV', // Tuvalu
  'VU', // Vanuatu
  'WF', // Wallis and Futuna
  'WS', // Samoa
]
const COUNTRIES = getCountries().filter((country) => !EXCLUDED_COUNTRIES.includes(country))

type Props = {
  error: any
  onChange: (value: string) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  defaultValue?: string
  value?: string
}

const EmtPhoneInput: React.FC<Props> = ({ onChange, value = '', defaultValue = '', error, onFocus, onBlur }) => {
  const { t } = useTranslation('connection')

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          border: (theme: any) => `1px solid ${theme.palette.greyGradient[100]}`,
          background: 'white',
          borderRadius: '16px',
          '& input': {
            //border: (theme: any) => `1px solid ${theme.palette.greyGradient[100]}`,
            border: 0,
            borderRadius: '16px',
            paddingRight: '16px',
            paddingLeft: '5px',
            paddingTop: '20px',
            paddingBottom: '12px',
            fontSize: '14px',
            fontWeight: 600,
            '&:focus': {
              outline: 'none',
            },
          },
          '& .PhoneInputCountry': {
            paddingLeft: '16px',
            '& .PhoneInputCountryIcon': {
              borderRadius: '3px',
              overflow: 'hidden',
            },
          },
          '& .PhoneInputInput': {
            color: (theme: any) => theme.palette.greyGradient.main,
          },
        }}
      >
        <EmtTypography
          variant="caption"
          sx={{
            position: 'absolute',
            fontSize: '10px',
            left: '61px',
            top: '5px',
            color: (theme: any) => theme.palette.greyGradient.light,
          }}
        >
          {t('create-your-profile.address-photo.labels.phone')}
        </EmtTypography>
        <PhoneInput
          international
          countries={COUNTRIES}
          defaultCountry={Constants.defaultLocal.toUpperCase() === 'EN' ? 'US' : Constants.defaultLocal.toUpperCase()}
          defaultValue={defaultValue}
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={(phoneNumber) =>
            onChange(
              formatPhoneNumberIntl(phoneNumber as string)
                .trim()
                .replaceAll(' ', ''),
            )
          }
        />
      </Box>
      {error ? (
        <EmtTypography variant="caption" color="error">
          {error}
        </EmtTypography>
      ) : null}
    </Box>
  )
}

export default EmtPhoneInput
